// @ts-expect-error not typed
import { DispatcherInstance } from 'general-store';
// @ts-expect-error not typed
import dispatcher from 'dispatcher/dispatcher';
DispatcherInstance.set(dispatcher);